import { render } from "./disband-modal.vue?vue&type=template&id=6a1415e6&scoped=true&ts=true"
import script from "./disband-modal.vue?vue&type=script&lang=ts"
export * from "./disband-modal.vue?vue&type=script&lang=ts"

import "./disband-modal.vue?vue&type=style&index=0&id=6a1415e6&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1415e6"]])

export default __exports__